export default "__VITE_ASSET__BQBnKNsu__"